<script>
export default {
  name: 'TwRadio',
  props: {
    modelValue: {
      type: [Boolean, String, Number],
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      SelectedValue: this.modelValue
    }
  },
  watch: {
    modelValue(newValue) {
      this.SelectedValue = newValue; // Keeps internal state in sync with external value
    },
  },
  methods: {
    getValue(option) {
      // Extracts the value from primitives or objects
      return typeof option === "object" ? option.value : option;
    },
    getText(option) {
      // Extracts the display text from primitives or objects
      return typeof option === "object" ? option.text : option;
    },
    updateValue() {
      this.$emit("update:modelValue", this.SelectedValue); // Emits updated value to parent
    },
  },
}
</script>

<template>
  <fieldset class="w-full">
    <slot name="label">
      <legend v-if="label" class="form-label">
        {{ label }}
      </legend>
    </slot>
    <p v-if="smallLabel" class="form-label-sm">
      {{ smallLabel }}
    </p>
    <div class="mt-2 space-y-6 sm:flex sm:items-center sm:space-x-8 sm:space-y-0">
      <div v-for="(option, index) in options" :key="'key-index' + index" class="flex items-center">
        <input
          :id="id + '-' + index" v-model="SelectedValue" :name="id" type="radio" class="h-6 w-6 border-gray-300 text-green-600 focus-ring-0"
          :value="getValue(option)"
          @change="updateValue"
        >
        <label :for="id" class="ml-2 block text-sm font-medium leading-6 text-gray-900 capitalize font-forms"> {{ getText(option) }} </label>
      </div>
    </div>
  </fieldset>
</template>

<style scoped>

</style>
